import React from 'react'
import { isEmpty } from 'lodash'

import PerfectScrollbar from 'react-perfect-scrollbar'
import { Box, Chip, Hidden, Paper, TablePagination } from '@material-ui/core'

import { LoadingFeedback, NoData2 } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import { ActionButtons, KpiMetricsDialog } from './components'

import constants from 'constants/index'
import * as service from 'service'
import helpers from 'helpers'

import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'

import useStyles from './styles'

const KpiMetricsTable = ({
  monitoringManagementKpi,
  openMetricModal,
  setOpenMetricModal,
}) => {
  const classes = useStyles()

  const { STATUSES } = constants.monitoringManagementKpi

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const monitoringManagementKpiId = monitoringManagementKpi?.id

  const { response, isLoading, refresh } = useFetch(
    service.dponet.monitoringManagementKpiMetrics.list,
    { monitoringManagementKpiId, perPage, page },
    [monitoringManagementKpiId, perPage, page],
    !!monitoringManagementKpiId,
  )

  const monitoringManagementKpiMetrics =
    response?.data?.monitoringManagementKpiMetrics || []

  return (
    <>
      <LoadingFeedback open={isLoading} />

      <Paper>
        {!isEmpty(monitoringManagementKpiMetrics) ? (
          <>
            <Box width="100%">
              <PerfectScrollbar
                options={{ wheelPropagation: false, useBothWheelAxes: true }}
              >
                <Table size="small" noWrap>
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>Período de Referência </TableCell>
                      <TableCell>Data de Periodicidade</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Responsável</TableCell>
                      <TableCell align="right">Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {monitoringManagementKpiMetrics?.map(
                      (monitoringManagementKpiMetric) => (
                        <TableRow key={monitoringManagementKpiMetric?.id}>
                          <TableCell>
                            {monitoringManagementKpiMetric?.id}
                          </TableCell>
                          <TableCell>
                            {helpers.formatters.date(
                              monitoringManagementKpiMetric?.period,
                              'MM/YYYY',
                            ) || '-'}
                          </TableCell>
                          <TableCell>
                            {helpers.formatters.date(
                              monitoringManagementKpiMetric?.date,
                            ) || '-'}
                          </TableCell>
                          <TableCell>
                            <Chip
                              size="small"
                              className={
                                classes[monitoringManagementKpiMetric?.status]
                              }
                              label={
                                STATUSES[monitoringManagementKpiMetric?.status]
                              }
                            />
                          </TableCell>
                          <TableCell>
                            {monitoringManagementKpiMetric?.assignee?.name}
                          </TableCell>
                          <TableCell align="right">
                            <ActionButtons
                              monitoringManagementKpi={monitoringManagementKpi}
                              monitoringManagementKpiMetric={
                                monitoringManagementKpiMetric
                              }
                              refresh={refresh}
                            />
                          </TableCell>
                        </TableRow>
                      ),
                    )}
                  </TableBody>
                </Table>
              </PerfectScrollbar>
            </Box>
            <TablePagination
              component="div"
              count={response?.data?.meta?.totalCount || 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              rowsPerPageOptions={[5, 10, 25, 100]}
              labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          </>
        ) : (
          !isLoading && <NoData2 title="Nenhuma métrica encontrada." />
        )}
      </Paper>
      <KpiMetricsDialog
        open={openMetricModal}
        setOpen={setOpenMetricModal}
        monitoringManagementKpi={monitoringManagementKpi}
        refresh={refresh}
        isCreate={true}
      />
    </>
  )
}

export default KpiMetricsTable
